"use client";

interface UserResetPasswordModalProps {
  userName: string;
  onClose: () => void;
  onSubmit: () => Promise<any>;
  isSubmitting?: boolean;
}

const DriverResetPasswordModal: React.FC<UserResetPasswordModalProps> = ({
  userName,
  onClose,
  onSubmit,
  isSubmitting = false,
}) => {
  const handleSubmit = async () => {
    await onSubmit();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 px-4">
      <div className="w-full max-w-md rounded-2xl bg-white p-6 shadow-2xl">
        <h3 className="text-lg font-semibold">Xác nhận đặt lại mật khẩu</h3>
        <p className="mt-2 text-sm text-slate-600">
          Bạn có chắc chắn muốn đặt lại mật khẩu cho người dùng:{" "}
          <b>{userName}</b>?
        </p>
        <div className="mt-6 flex justify-end gap-3">
          <button
            onClick={onClose}
            disabled={isSubmitting}
            className="rounded-full border px-4 py-2"
          >
            Hủy
          </button>
          <button
            onClick={handleSubmit}
            disabled={isSubmitting}
            className="rounded-full bg-indigo-600 px-4 py-2 text-white disabled:opacity-60"
          >
            {isSubmitting ? "Đang xử lý..." : "Xác nhận"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DriverResetPasswordModal;
